import {
  AutomationActionLessonlyAssignToContentDenormalized,
  IAutomationActionTemplateLessonlyAssignToContent
} from '@dadohr/shared/domainTypes/experience';
import { LessonlyContentType } from '@dadohr/shared/domainTypes/integrations/lessonly';
import { useUnsafeTranslation } from '../../../../../../../i18next';
import { joinWithCommaAndAnd } from '../../../../../../../services/enumerate';
import { LightMdToJsx } from '../../../../../../../services/formatter';
import { MinimalTaskBuilderContext } from '../../../TaskBuilder/types';
import { actionActorToString } from '../../shared';
import { ActionDefinition } from '../../types';
import {
  ActionSummaryBody,
  ActionSummaryContainer,
  ActionSummaryHeading
} from '../shared';

export const ActionSummaryLessonlyAssignToContent = ({
  a,
  expTpl,
  def
}: {
  a:
    | IAutomationActionTemplateLessonlyAssignToContent
    | AutomationActionLessonlyAssignToContentDenormalized;
  expTpl: MinimalTaskBuilderContext;
  def: ActionDefinition;
}) => {
  const { t } = useUnsafeTranslation();
  return (
    <ActionSummaryContainer>
      <ActionSummaryHeading def={def} />
      <ActionSummaryBody>
        <LightMdToJsx>
          {t(
            'Assign **{{ participants }}** to the {{ contentType }} **{{ content }}**.',
            {
              participants:
                joinWithCommaAndAnd(
                  a.pplToAdd.map((o) =>
                    actionActorToString(o, expTpl.supportingActors, t)
                  ),
                  t
                ) || 'someone',
              content: a.content.name || 'TBD',
              // Anything that isn't a lesson (incl. a legacy 'certification')
              // is assigned as a path.
              contentType:
                a.content.type === LessonlyContentType.LESSON ? t('Lesson') : t('Path')
            }
          )}
        </LightMdToJsx>
      </ActionSummaryBody>
    </ActionSummaryContainer>
  );
};
